import { t, useI18n } from "@bookingcom/lingojs-react";
import useProfiler from "../../../../../../../hooks/useProfiler.js";
const useBaggageInfoController = (flight) => {
    const i18n = useI18n();
    const { isAmerican } = useProfiler();
    const { segments, includedProducts, baggagePolicies } = flight;
    return {
        header: i18n.trans(t("flights_included_baggage_title")),
        subheader: i18n.trans(t("flights_included_baggage_sub")),
        segments,
        includedProducts: Boolean(includedProducts?.segments.some((segment) => segment.length > 0))
            ? includedProducts
            : undefined,
        baggagePolicies: baggagePolicies && isAmerican() ? baggagePolicies : undefined
    };
};
export default useBaggageInfoController;
